import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/stable';
import CityOfEvanston from './CityOfEvanston';

const rootElement = document.getElementById('smk-city-of-evanston-widget');

ReactDOM.render(
    <CityOfEvanston />,
    rootElement
);
